import React from "react";

let initData ={
  heading: "L'application Kehila",
  content: "La vie communautaire au plus proche de vous.",
  image:    "/img/waves-shape.svg",
  sliderImage: "/img/iphone-x-frame.png",
}
let slider_action_data = [
  {
    link: "https://apps.apple.com/fr/app/kehila/id6444421357",
    btnClass: "btn softo-solid-btn",
    faClass: "fa-brands fa-apple",
    value: "App Store"
  },
  {
    link: "https://play.google.com/store/apps/details?id=com.mimtech.kehila&hl=fr",
    btnClass: "btn softo-solid-btn",
    faClass: "fa-brands fa-google-play",
    value: "Google Play"
  }
];
let phoneImage = [
  "/img/app/app1.png",
  "/img/app/app2.png",
  "/img/app/app3.png",
  "/img/app/app4.png",
  "/img/app/app5.png",
  "/img/app/app6.png",
];

class HeroSection extends React.Component {
  // noinspection JSAnnotator
  state = {
    initData: {},
    sliderData: [],
    phoneImage: []
  };
  componentDidMount() {

    // you can do this by make a api call
    // axios
    //   .get(`${URL}`)
    //   .then(res => {
    //     this.setState({
    //       initData ....
    //     });
    //     // console.log(this.state.sliderData);
    //   })
    //   .catch(err => console.log(err));

    this.setState({
      initData: initData,
      sliderData: slider_action_data,
      phoneImage: phoneImage
    })
  }

  render() {
    return (
      <div>
        {/* start hero section */}
        <section id="hero" className="section-lg section-hero section-circle">
          {/* background circle shape */}
          <div className="shape shape-style-1 shape-primary">
            <span className="circle-150"></span>
            <span className="circle-50"></span>
            <span className="circle-50"></span>
            <span className="circle-75"></span>
            <span className="circle-100"></span>
            <span className="circle-75"></span>
            <span className="circle-50"></span>
            <span className="circle-100"></span>
            <span className="circle-50"></span>
            <span className="circle-100"></span>
          </div>
          {/* background circle shape */}
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="hero-content-wrap">
                  <div className="hero-content">
                    <h1>{this.state.initData.heading}</h1>
                    <p>{this.state.initData.content}</p>
                    <div className="slider-action-btn">
                      {this.state.sliderData.map((data, idx) => {
                        return (
                          <a key={`sk_${idx}`} href={data.link} className={data.btnClass}>
                            <i className={data.faClass}></i> {data.value}
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mobile-slider-area">
                  <div className="phone" style={{}}>
                    <img src={this.state.initData.sliderImage} alt="" className="img-responsive" style={{opacity:0}}/>
                    <div className="mobile-slider owl-carousel owl-theme">
                      {this.state.phoneImage.map((item, idx) => {
                        return (
                          <div key={`pi_${idx}`} className="item">
                            <img src={item} alt="" className="img-responsive" />
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="slider-indicator">
                    <ul>
                      <li id="prev">
                        <i className="fa fa-angle-left"></i>
                      </li>
                      <li id="next">
                        <i className="fa fa-angle-right"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="section-shape">
            <img src={this.state.initData.image} alt="" />
          </div>
        </section>
        {/* end hero section */}
      </div>
    );
  }
}

export default HeroSection;
